import '../scss/fincap.scss';
import setupAccordion from './modules/accordion.js';
import setupAlertBanner from './modules/alert-banner.js';
import setupArticlesSearch from './modules/articles-search.js';
import setupMentorLocator from './modules/mentor-locator.js';
import setupMobileMenu from './modules/mobile-menu.js';
import setupEventsCalendarLayout from './modules/events-calendar.js';
import setupHomeNewsCarousel from './modules/home-news-carousel.js';
import setupTeTapapa from './modules/tetapapa.js';
import setupForumRichText from './modules/forum-rich-text.js';
import setupProfileTabs from './modules/profile-tabs.js';
import setupAnchorOffsetScroll from './modules/anchor-offset-scroll.js';

setupAccordion();
setupAlertBanner();
setupArticlesSearch();
setupMentorLocator();
setupMobileMenu();
setupEventsCalendarLayout();
setupHomeNewsCarousel();
setupTeTapapa();
setupForumRichText();
setupProfileTabs();
setupAnchorOffsetScroll();
